
export const BONUS_FORMATS: Readonly<Record<number, string>> = {
  1: "Max. HP +%d", // APPLY_MAX_HP, TOOLTIP_MAX_HP
  2: "Max. SP +%d", // APPLY_MAX_SP, TOOLTIP_MAX_SP
  3: "Vitality +%d", // APPLY_CON, TOOLTIP_CON
  4: "Intelligence +%d", // APPLY_INT, TOOLTIP_INT
  5: "Strength +%d", // APPLY_STR, TOOLTIP_STR
  6: "Dexterity +%d", // APPLY_DEX, TOOLTIP_DEX
  7: "Attack Speed +%d%%", // APPLY_ATT_SPEED, TOOLTIP_ATT_SPEED
  8: "Moving Speed %d%%", // APPLY_MOV_SPEED, TOOLTIP_MOV_SPEED
  9: "Casting Speed +%d%%", // APPLY_CAST_SPEED, TOOLTIP_CAST_SPEED
  10: "HP Regeneration +%d%%", // APPLY_HP_REGEN, TOOLTIP_HP_REGEN
  11: "SP Regeneration +%d%%", // APPLY_SP_REGEN, TOOLTIP_SP_REGEN
  12: "Poisoning chance %d%%", // APPLY_POISON_PCT, TOOLTIP_APPLY_POISON_PCT
  13: "Blackout chance %d%%", // APPLY_STUN_PCT, TOOLTIP_APPLY_STUN_PCT
  14: "Slowing chance %d%%", // APPLY_SLOW_PCT, TOOLTIP_APPLY_SLOW_PCT
  15: "Chance of critical hit +%d%%", // APPLY_CRITICAL_PCT, TOOLTIP_APPLY_CRITICAL_PCT
  16: "%d%% Chance for piercing Hits", // APPLY_PENETRATE_PCT, TOOLTIP_APPLY_PENETRATE_PCT
  17: "Strong against Half Humans +%d%%", // APPLY_ATTBONUS_HUMAN, TOOLTIP_APPLY_ATTBONUS_HUMAN
  18: "Strong against Animals +%d%%", // APPLY_ATTBONUS_ANIMAL, TOOLTIP_APPLY_ATTBONUS_ANIMAL
  19: "Strong against Orcs +%d%%", // APPLY_ATTBONUS_ORC, TOOLTIP_APPLY_ATTBONUS_ORC
  20: "Strong against Mystics +%d%%", // APPLY_ATTBONUS_MILGYO, TOOLTIP_APPLY_ATTBONUS_MILGYO
  21: "Strong against Undead +%d%%", // APPLY_ATTBONUS_UNDEAD, TOOLTIP_APPLY_ATTBONUS_UNDEAD
  22: "Strong against Devils +%d%%", // APPLY_ATTBONUS_DEVIL, TOOLTIP_APPLY_ATTBONUS_DEVIL
  23: "%d%% damage will be absorbed by HP", // APPLY_STEAL_HP, TOOLTIP_APPLY_STEAL_HP
  24: "%d%% damage will be absorbed by SP", // APPLY_STEAL_SP, TOOLTIP_APPLY_STEAL_SP
  25: "%d%% chance to rob SP", // APPLY_MANA_BURN_PCT, TOOLTIP_APPLY_MANA_BURN_PCT
  27: "Chance to block a close-combat attack %d%%", // APPLY_BLOCK, TOOLTIP_APPLY_BLOCK
  28: "Chance to avoid Arrows %d%%", // APPLY_DODGE, TOOLTIP_APPLY_DODGE
  29: "Sword Defence %d%%", // APPLY_RESIST_SWORD, TOOLTIP_APPLY_RESIST_SWORD
  30: "Two-Handed Defence %d%%", // APPLY_RESIST_TWOHAND, TOOLTIP_APPLY_RESIST_TWOHAND
  31: "Dagger Defence %d%%", // APPLY_RESIST_DAGGER, TOOLTIP_APPLY_RESIST_DAGGER
  32: "Bell Defence %d%%", // APPLY_RESIST_BELL, TOOLTIP_APPLY_RESIST_BELL
  33: "Fan Defence %d%%", // APPLY_RESIST_FAN, TOOLTIP_APPLY_RESIST_FAN
  34: "Arrow Resistance %d%%", // APPLY_RESIST_BOW, TOOLTIP_RESIST_BOW
  35: "Fire Resistance %d%%", // APPLY_RESIST_FIRE, TOOLTIP_RESIST_FIRE
  36: "Lightning Resistance %d%%", // APPLY_RESIST_ELEC, TOOLTIP_RESIST_ELEC
  37: "Magic Resistance %d%%", // APPLY_RESIST_MAGIC, TOOLTIP_RESIST_MAGIC
  38: "Wind Resistance %d%%", // APPLY_RESIST_WIND, TOOLTIP_APPLY_RESIST_WIND
  39: "%d%% Chance to reflect close combat hits", // APPLY_REFLECT_MELEE, TOOLTIP_APPLY_REFLECT_MELEE
  41: "Poison Resistance %d%%", // APPLY_POISON_REDUCE, TOOLTIP_APPLY_POISON_REDUCE
  43: "%d%% Chance for EXP Bonus", // APPLY_EXP_DOUBLE_BONUS, TOOLTIP_APPLY_EXP_DOUBLE_BONUS
  44: "%d%% Chance to drop double Yang", // APPLY_GOLD_DOUBLE_BONUS, TOOLTIP_APPLY_GOLD_DOUBLE_BONUS
  45: "%d%% Chance to drop double the Items", // APPLY_ITEM_DROP_BONUS, TOOLTIP_APPLY_ITEM_DROP_BONUS
  48: "Defence against blackouts", // APPLY_IMMUNE_STUN, TOOLTIP_APPLY_IMMUNE_STUN
  49: "Defence against slowing", // APPLY_IMMUNE_SLOW, TOOLTIP_APPLY_IMMUNE_SLOW
  53: "Attack Value +%d", // APPLY_ATT_GRADE_BONUS, TOOLTIP_ATT_GRADE
  54: "Defence +%d", // APPLY_DEF_GRADE_BONUS, TOOLTIP_DEF_GRADE
  59: "Strong against Warriors +%d%%", // APPLY_ATTBONUS_WARRIOR, TOOLTIP_APPLY_ATTBONUS_WARRIOR
  60: "Strong against Ninjas +%d%%", // APPLY_ATTBONUS_ASSASSIN, TOOLTIP_APPLY_ATTBONUS_ASSASSIN
  61: "Strong against Sura +%d%%", // APPLY_ATTBONUS_SURA, TOOLTIP_APPLY_ATTBONUS_SURA
  62: "Strong against Shamans +%d%%", // APPLY_ATTBONUS_SHAMAN, TOOLTIP_APPLY_ATTBONUS_SHAMAN
  63: "Strength against monsters +%d%%", // APPLY_ATTBONUS_MONSTER, TOOLTIP_APPLY_ATTBONUS_MONSTER
  78: "Defence chance against warrior attacks: %d%%", // APPLY_RESIST_WARRIOR, TOOLTIP_APPLY_RESIST_WARRIOR
  79: "Defence chance against ninja attacks: %d%%", // APPLY_RESIST_ASSASSIN, TOOLTIP_APPLY_RESIST_ASSASSIN
  80: "Defence chance against sura attacks: %d%%", // APPLY_RESIST_SURA, TOOLTIP_APPLY_RESIST_SURA
  81: "Defence chance against shaman attacks: %d%%", // APPLY_RESIST_SHAMAN, TOOLTIP_APPLY_RESIST_SHAMAN
  87: "Ice resistance +%d%%", // APPLY_RESIST_ICE, TOOLTIP_RESIST_ICE
  88: "Earth resistance +%d%%", // APPLY_RESIST_EARTH, TOOLTIP_RESIST_EARTH
  89: "Resistance against darkness +%d%%", // APPLY_RESIST_DARK, TOOLTIP_RESIST_DARK
};

export function formatItemBonus(apply: number, value: number): string | null {
  if (apply === 0 || value === 0) return null;
  const format = BONUS_FORMATS[apply];
  if (format === undefined) return `UNKNOWN_TYPE[${apply}] ${value}`;
  // The value first, then the escape: `%d` becomes the number and `%%` a
  // literal per cent. No shipped format contains `%%d`, so the two orders agree
  // today -- this is the one that stays correct if one ever does.
  return format.replace("%d", String(value)).replace(/%%/g, "%");
}
